<ng-container *clientScreen="let isDesktop = isDesktop">
	<pre>{{ opened }}</pre>
	@if (opened) {
		<div
			moveToRoot
			class="backdrop w-100 h-100 pos-fixed pos-t-0 pos-l-0 p-safe border-box bg-backdrop"
			(click)="outsideClick()"
		>
			<div class="w-100 h-100 fl fl-ai-c fl-jc-c ws-pl wb-bw">
				<div
					class="container bg-180 fl fl-dir-c fl-ai-c fl-jc-fs ov-auto shadow-menu"
					[class.desktop]="isDesktop"
					[class.full-size]="fullSize"
					[class.mobile]="!isDesktop"
					(click)="$event.stopPropagation()"
				>
					<div class="fl-fixed w-100 h-sp-4 fl fl-ai-c fl-jc-fe">
						@if (showClose) {
							<button uiNewButtonIcon size="SMALL" (click)="close()">
								<i class="icon-cross-close"></i>
							</button>
						}
					</div>
					<div class="fl-adaptable w-100 ov-auto">
						<ng-content></ng-content>
					</div>
					<div
						class="fl-fixed w-100 border-box fl fl-ai-c"
						[class.p-1q-tb]="!isDesktop"
						[class.p-4-rl]="!isDesktop"
						[class.fl-jc-c]="!isDesktop"
						[class.fl-jc-fe]="isDesktop"
					>
						<ng-content select="[footer]"></ng-content>
					</div>
				</div>
			</div>
		</div>
	}
</ng-container>
